import React, { useEffect } from 'react'
import Skills from '../../Components/Skills/Skills'
import './SkillsPage.scss'
import SplitType from 'split-type';
import { gsap } from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger';

//-Components
import Contact from '../../Components/Contact/Contact';

function SkillsPage() {
    //page title
    useEffect(() => {
        document.title = 'Aprameya Shankar: Skills and Certifications';
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        window.scrollTo(0, 0);
    }, []);
	// mobile tab bar height adjustment
    useEffect(() => {
        const isTouch = (('ontouchstart' in window) || (navigator.msMaxTouchPoints > 0));
        if(isTouch || window.innerWidth<=500){
            document.querySelector(".page-hero").style.height = "calc(100vh - 50px)"    
            document.querySelector(".black-pulldown").style.display = "none !important";
        }
    }, [])
    //black pulldown anim
    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);
        gsap.to(".black-pulldown", {
            scrollTrigger: {
                trigger: ".main-dark",
                scrub: true,
            },
            scaleY: 2,
        })
        gsap.to('.page-hero-wrapper', {
            scrollTrigger: {
                trigger: ".main-dark",
                scrub: true,
            },
            autoAlpha: 0,
            opacity: 0
        })
    }, [])
    //hero animation
    useEffect(() => {
        const split = new SplitType('.h-t')
        // clip-path: polygon(0 0, 0 0, 0 100%, 0 100%);
        gsap.from('.h-t-1 .char', {
            duration: 0.3,
            y: '126',
            stagger: 0.06
        })
        gsap.to('.h-t-2', {
            duration: 0.7,
            clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
            delay: 0.6
        })
        gsap.from('.h-t-3 .char', {
            duration: 0.3,
            y: '126',
            stagger: 0.06,
            delay: 1.1,
        })
        gsap.to('.h-t-4', {
            duration: 0.7,
            clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0 100%)',
            delay: 1.8
        })
        gsap.from('.h-t-4 .char', {
            duration: 0.3,
            y: '126',
            stagger: 0.06,
            delay: 2.3
        })

    })
    

    return <>
        <div className='noise-div'></div>
        <div className="wrapper workpage-wrapper">
            <div className='black-pulldown'></div>
            <section className='page-hero'>
                <div className='page-hero-wrapper'>
                    <div className='h-top hero-text'>
                        <h1>
                            <span className='h-t h-t-1'>USED BY</span><br/>
                            <span className='h-t blank-h-t h-t-2' style={{color: "transparent"}}>________-</span>
                        </h1>
                    </div>
                    <div className='h-bottom hero-text'>
                        <h1>
                            <span className='h-t h-t-3'>MY HANDS</span><br/>
                            <span className='h-t  h-t-4'>AND MIND</span>
                        </h1>
                    </div>
                    <div className='scroll-down'>
                        <span className='arrow'>↓</span><br/>
                        <span>scroll</span>
                    </div>
                </div>
            </section>
            <div className='main main-dark'></div>
            <Skills />
            <div className='fade-flag'></div>    
            <Contact />       
        </div>
    </>
}

export default SkillsPage